var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color } from '@socgress/ui/themes';
var InputLabel = function (_a) {
    var forProp = _a.for, title = _a.children, subtitle = _a.subtitle, props = __rest(_a, ["for", "children", "subtitle"]);
    return (React.createElement(LabelElement, __assign({ htmlFor: forProp }, props),
        React.createElement(Title, null, title),
        subtitle && React.createElement(Subtitle, null, subtitle)));
};
InputLabel.propTypes = {
    for: PropTypes.string,
    children: PropTypes.node,
    subtitle: PropTypes.string,
};
InputLabel.defaultProps = {
    for: null,
    children: null,
    subtitle: null,
};
export { InputLabel };
var LabelElement = styled.label.withConfig({ displayName: "LabelElement", componentId: "sc-15eang2" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 14px;\n  margin-bottom: 5px;\n"], ["\n  display: block;\n  font-size: 14px;\n  margin-bottom: 5px;\n"])));
var Title = styled.div.withConfig({ displayName: "Title", componentId: "sc-steene" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 500;\n"], ["\n  color: ", ";\n  font-weight: 500;\n"])), color('textMain'));
var Subtitle = styled.div.withConfig({ displayName: "Subtitle", componentId: "sc-2nc5sn" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-top: 5px;\n  line-height: 18px;\n  font-weight: 500;\n  font-size: 13px;\n"], ["\n  color: ", ";\n  margin-top: 5px;\n  line-height: 18px;\n  font-weight: 500;\n  font-size: 13px;\n"])), color('textSecondary'));
var templateObject_1, templateObject_2, templateObject_3;
